import React from 'react';
import HeaderComponent from '../../header';

const Header = ({ navOpen, privilegeData }) => {
  return (
    <div
      className={`${
        navOpen ? 'left-200p w-84per' : 'left-65p  w-94per'
      } fixed header flex justify-end dark:bg-gray-800 dark:text-white`}
    >
      <HeaderComponent privilegeData={privilegeData} />
    </div>
  );
};

export default Header;
